/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-03-25 14:29:15
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-12-12 10:40:51
 * @FilePath: \lightning\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import home from "../views/home"
import warning from "../views/warning"
import inspection from "../views/inspection"
import set from "../views/set"
import userManage from "../views/set/UserManage"
import modifyLog from "../views/set/ModifyLog"
import deviceManage from "../views/set/DeviceManage"
import test from "../views/test"
import login from "../views/Login"
import main from "../views/main"
Vue.use(VueRouter)

const routes = [

   
  {
    path: '/',
    name: 'login',
    component: login,
   
  },
  {
    path: '/main',
    name: 'main',
    component: main,
    children: [
      {
        path: '/home',
      
        component: home

      },
      {
        path: '/warning',
      
        component: warning

      },
      {
        path: '/inspection',
      
        component: inspection

      },
      {
        path: '/set',
        component: set,
        redirect: '/set/userManage',
        children: [
          {
            path: 'userManage',
            name: 'userManage',
            component: userManage
          },
          {
            path: 'modifyLog',
            name: 'modifyLog',
            component: modifyLog
          },
          {
            path: 'deviceManage',
            name: 'deviceManage',
            component: deviceManage
          }
        ]
      },
    ],
  },
 
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
